import React from 'react';
import { ForgotPasswordForm } from '../../components/auth';

export const ForgotPasswordPage: React.FC = () => {
  return <ForgotPasswordForm />;
};